import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { BaseCard } from "./BaseCard.js";
import { CardHeader } from "./internal/CardHeader.js";
import { IconButton } from "../icon-button/IconButton.js";
import highlightedcard_module_default from "./highlightedcard.module.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/card/HighlightedCard.tsx
const ICON_WRAPPER_DIRECTION = {
	left: "row",
	right: "row-reverse"
};
const ICON_WRAPPER_JUSTIFY = {
	left: "initial",
	right: "space-between"
};
const HighlightedCard = ({ children, footer, header, Icon, iconPosition = "left", color = "primary", onIconClick, onClick, role, sharp = false, pinFooter, fullHeight, "data-testid": testId }) => {
	const colorProps = useTheme().other.getStyleForColor(color);
	let Header;
	if (Icon) Header = /* @__PURE__ */ jsxs(Flex, {
		gap: "xxxs",
		justify: ICON_WRAPPER_JUSTIFY[iconPosition],
		direction: ICON_WRAPPER_DIRECTION[iconPosition],
		children: [onIconClick ? /* @__PURE__ */ jsx(IconButton, {
			onClick: onIconClick,
			Icon,
			color,
			withStyles: false
		}) : /* @__PURE__ */ jsx(Icon, { color }), /* @__PURE__ */ jsx(CardHeader, {
			color: colorProps.bg,
			children: header
		})]
	});
	else Header = /* @__PURE__ */ jsx(CardHeader, {
		color: colorProps.bg,
		children: header
	});
	return /* @__PURE__ */ jsx(BaseCard, {
		withBorder: true,
		footer,
		header: Header,
		pinFooter,
		fullHeight,
		variant: "filled",
		padding: "sm",
		radius: sharp ? "0" : "sm",
		classNames: highlightedcard_module_default,
		style: { borderColor: "var(--card-border-color)" },
		__vars: {
			"--card-border-color": `var(--mantine-color-${color}-7)`,
			"--card-header-bg-color": `var(--mantine-color-${color}-0)`,
			"--card-header-padding-bottom": "var(--card-padding)"
		},
		onClick,
		role,
		"data-testid": testId,
		children
	});
};

//#endregion
export { HighlightedCard };